import PropTypes from 'prop-types';
import React from 'react';
import ButtonV2 from '../ButtonV2';
import Card from '../Card';
import { ActionsList } from './StyledComponents';

const QuickActions = ({
  title = 'Quick Actions',
  actions = [],
  accentTitle = false,
  ...props
}) => {
  return (
    <Card title={title} accentTitle={accentTitle} compact {...props}>
      <ActionsList>
        {actions.map((action, index) => {
          // If action has a custom component, render it
          if (action.component) {
            return (
              <React.Fragment key={index}>{action.component}</React.Fragment>
            );
          }

          // Otherwise render default ButtonV2 with elevated style
          return (
            <ButtonV2
              key={index}
              elevated
              onClick={action.onClick}
              disabled={action.disabled}
              icon={action.icon}
              title={
                action.disabled
                  ? action.disabledReason || action.title
                  : action.title
              }
            >
              {action.label}
            </ButtonV2>
          );
        })}
      </ActionsList>
    </Card>
  );
};

QuickActions.propTypes = {
  title: PropTypes.string,
  accentTitle: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      icon: PropTypes.node,
      disabled: PropTypes.bool,
      disabledReason: PropTypes.string, // Tooltip text when button is disabled
      title: PropTypes.string, // Tooltip text (for all states)
      component: PropTypes.node, // Optional custom component to render instead of ButtonV2
    })
  ).isRequired,
};

export default QuickActions;
